export default "__VITE_ASSET__B3pmEw3W__"